var Request = require('../helper/request');
var Storage = require('../helper/storage');
var Feed = require('./feed');
var PasswordAssignment = require('./passwordAssignment');
var BranchAssignment = require('./branchAssignment');
var Connection = require('./connection');
var TagAssignment = require('./tagAssignment');
var Completion = require('./completion');
var FeedCompletion = require('./feedCompletion');
var DeviceInformation = require('./deviceInformation');
var State = require('./state');
var Location = require('./location');
var CategoryAssignment = require('./categoryAssignment');
var ProfileImage = require('./profileImage');
var Skill = require('./skill');
var FeedAction = require('./feedAction');
var SpecificationAssignment = require('./specificationAssignment');
var Notification = require('./notification');
var Advertisement = require('./advertisement');
var AdvertisementAction = require('./advertisementAction');
var Permission = require('./permission');
var Subscription = require('./feed/subscription');
var Language = require('./language');
var TermAction = require('./termAction');

function User(app){
  var self = this;
  self.app = app;
  self.request = new Request(app);

  self.routes = {
    index: {
      url: "/iam/user",
      method: "GET"
    },
    show: {
      url: "/iam/user/:id",
      method: "GET"
    },
    create: {
      url: "/iam/user",
      method: "POST"
    },
    update: {
      url: "/iam/user/:id",
      method: "PUT",
    },
    delete: {
      url: "/iam/user/:id",
      method: "DELETE"
    }
  }
}

User.prototype.index = function(){
  var self = this;
  return self.request.get(self.routes.index.url);
}

User.prototype.show = function(id){
  var self = this;
  var uri = self.routes.show.url.replace(':id', id);
  return self.request.get(uri);
}

User.prototype.create = function(data){
  var self = this;
  return self.request.post(self.routes.create.url, {
    user: data
  });
}

User.prototype.update = function(id, data){
  var self = this;
  var uri = self.routes.update.url.replace(':id', id);
  return self.request.put(uri, {
    user: data
  });
}

User.prototype.patch = function(id, data){
  var self = this;
  var uri = self.routes.update.url.replace(':id', id);
  return self.request.patch(uri, {
    user: data
  });
}

User.prototype.delete = function(id){
  var self = this;
  var uri = self.routes.delete.url.replace(':id', id);
  return self.request.delete(uri);
}

User.prototype.feed = function(userId){
  var self = this;
  return new Feed(self.app, userId);
}

User.prototype.passwordAssignment = function(userId){
  var self = this;
  return new PasswordAssignment(self.app, userId);
}

User.prototype.branchAssignment = function(userId){
  var self = this;
  return new BranchAssignment(self.app, userId);
}

User.prototype.connection = function(userId){
  var self = this;
  return new Connection(self.app, userId);
}

User.prototype.tagAssignment = function(userId){
  var self = this;
  return new TagAssignment(self.app, userId);
}

User.prototype.completion = function(userId){
  var self = this;
  return new Completion(self.app, userId);
}

User.prototype.feedCompletion = function(userId){
  var self = this;
  return new FeedCompletion(self.app, userId);
}

User.prototype.deviceInformation = function(userId){
  var self = this;
  return new DeviceInformation(self.app, userId);
}

User.prototype.state = function(userId){
  var self = this;
  return new State(self.app, userId);
}

User.prototype.location = function(userId){
  var self = this;
  return new Location(self.app, userId);
}

User.prototype.categoryAssignment = function(userId){
  var self = this;
  return new CategoryAssignment(self.app, userId);
}

User.prototype.profileImage = function(userId){
  var self = this;
  return new ProfileImage(self.app, userId);
}

User.prototype.skill = function(userId){
  var self = this;
  return new Skill(self.app, userId);
}

User.prototype.feedAction = function(userId){
  var self = this;
  return new FeedAction(self.app, userId);
}

User.prototype.feedSubscription = function(userId){
  var self = this;
  return new Subscription(self.app, userId);
}

User.prototype.specificationAssignment = function(userId){
  var self = this;
  return new SpecificationAssignment(self.app, userId);
}

User.prototype.notification = function(userId){
  var self = this;
  return new Notification(self.app, userId);
}

User.prototype.advertisement = function(userId){
  var self = this;
  return new Advertisement(self.app, userId);
}

User.prototype.advertisementAction = function(userId){
  var self = this;
  return new AdvertisementAction(self.app, userId);
}

User.prototype.permission = function(userId){
  var self = this;
  return new Permission(self.app, userId);
}

User.prototype.language = function(userId){
  var self = this;
  return new Language(self.app, userId);
}

User.prototype.termAction = function(userId){
  var self = this;
  return new TermAction(self.app, userId)
}

module.exports = User;
